import { memo, useState } from 'react';
import { useDebounce } from 'use-debounce';

import { type BaseStringSelectProps, StringSelect } from '~/components/StringSelect';
import { usePrivateCameraMakesList } from '~/swr-hooks/filters/usePrivateCameraMakesList';

type PrivateCameraMakeSelectProps = {
  boardId: string | undefined;
  libraryId: string | undefined;
} & BaseStringSelectProps;

export const PrivateCameraMakeSelect = memo(({ boardId, libraryId, ...props }: PrivateCameraMakeSelectProps) => {
  const [searchValue, setSearchValue] = useState('');

  const [debouncedSearchValue] = useDebounce(searchValue, 200, {
    trailing: true,
  });

  const { data = [], isLoading } = usePrivateCameraMakesList({
    search: debouncedSearchValue,
    boardId,
    libraryId,
  });

  return (
    <StringSelect
      id="camera-make"
      placeholder="Search for make"
      isSingleSelect={true}
      isLoading={isLoading}
      values={data}
      onInputChange={setSearchValue}
      {...props}
    />
  );
});

PrivateCameraMakeSelect.displayName = 'PrivateCameraMakeSelect';
